import React from "react";

import DesignerCards from "./DesignerCards";

import DesignerChart from "./DesignerChart";

import DesignerLeaderboard from "./DesignerLeaderboard";

import DesignerHeatmap from "./DesignerHeatmap";
import DesignerTable from "./DesignerTable";


const DesignerDashboard = () => {

return (

<div className="container-fluid p-4">

<h3 className="mb-4">Designer Performance Dashboard</h3>

<DesignerCards/>

<div className="row mt-4">

<div className="col-md-8">
<DesignerChart/>
</div>

<div className="col-md-4">
<DesignerLeaderboard/>
</div>

</div>

<div className="row mt-4">

<div className="col-md-6">
<DesignerHeatmap/>
</div>

<div className="col-md-6">
<DesignerTable/>
</div>

</div>

</div>

);

};

export default DesignerDashboard;